import React, { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Modal,
  StyleSheet,
  SafeAreaView,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { Opportunity } from "../types";
import ReportIssueForm from "./ReportIssueForm";
import SuggestOpportunityForm from "./SuggestOpportunityForm";

interface FeedbackModalProps {
  isVisible: boolean;
  onClose: () => void;
  opportunity?: Opportunity;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  isVisible,
  onClose,
  opportunity,
}) => {
  const navigation = useNavigation();
  const [activeForm, setActiveForm] = useState<"menu" | "issue" | "suggest">(
    "menu",
  );

  const closeAll = () => {
    setActiveForm("menu");
    onClose();
  };

  const handleContactPress = () => {
    onClose();
    navigation.navigate('Contact' as never);
  };

  return (
    <>
      <Modal
        visible={isVisible && activeForm === "menu"}
        animationType="fade"
        transparent
        onRequestClose={onClose}
        data-oid="yqz.hkc"
      >
        <SafeAreaView style={styles.safeArea} data-oid="z3yttx1">
          <View style={styles.container} data-oid="6:96jn8">
            <Text style={styles.title} data-oid="8kv_ny:">
              How can we help?
            </Text>
            <TouchableOpacity
              style={styles.option}
              onPress={() => setActiveForm("issue")}
              data-oid="lca6bum"
            >
              <Ionicons
                name="alert-circle-outline"
                size={24}
                color="#2D3748"
                data-oid="uw5wh_z"
              />

              <Text style={styles.optionText} data-oid="0ex1.bq">
                Report an Issue
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.option}
              onPress={() => setActiveForm("suggest")}
              data-oid="fbh0rhf"
            >
              <Ionicons
                name="bulb-outline"
                size={24}
                color="#2D3748"
                data-oid="ink_alg"
              />

              <Text style={styles.optionText} data-oid="1.dsnb_">
                Suggest an Opportunity
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.option}
              onPress={handleContactPress}
            >
              <Ionicons
                name="mail-outline"
                size={24}
                color="#2D3748"
              />

              <Text style={styles.optionText}>
                Contact Us
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={onClose}
              data-oid="isnmzev"
            >
              <Ionicons
                name="close"
                size={24}
                color="#4A5568"
                data-oid="_m0ihqk"
              />
            </TouchableOpacity>
          </View>
        </SafeAreaView>
      </Modal>
      <ReportIssueForm
        isVisible={isVisible && activeForm === "issue"}
        onClose={closeAll}
        opportunity={opportunity}
        data-oid="9yqy6_x"
      />

      <SuggestOpportunityForm
        isVisible={isVisible && activeForm === "suggest"}
        onClose={closeAll}
        data-oid="7tpmqyl"
      />


    </>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.5)",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    width: "80%",
    maxWidth: 400,
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 24,
    alignItems: "stretch",
    gap: 16,
  },
  title: {
    fontSize: 18,
    fontWeight: "600",
    color: "#2D3748",
    textAlign: "center",
    fontFamily: "Inter-SemiBold",
  },
  option: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: "#E2E8F0",
    borderRadius: 8,
  },
  optionText: {
    marginLeft: 12,
    fontSize: 16,
    color: "#2D3748",
    fontFamily: "Inter-Regular",
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    padding: 8,
  },
});

export default FeedbackModal;
